import { createFileRoute } from "@tanstack/react-router";
import { CitiesLegacyRedirect } from "@/pages/legacy/LegacyRedirects";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/cities/$city/")({
  head: ({ params }) => routeHead("/cities/$city/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CitiesLegacyRedirect />
  );
}
